import { Component, Input, OnInit } from '@angular/core';
import AccreditationComponentView from './accreditation.component.html';
import { EventGuestAccreditation } from '../../../../shared/models/events/guests/event-guest-accreditation.model';

@Component({
  selector: 'accreditation',
  template: AccreditationComponentView
})
export class AccreditationComponent implements OnInit {
  @Input() data: EventGuestAccreditation | null;

  constructor() { }

  ngOnInit() {
  }

}
